<template>
  <div class="login-page">
    <div class="login-page__glow login-page__glow--left"></div>
    <div class="login-page__glow login-page__glow--right"></div>

    <div class="login-page__scroll">
      <div class="login-page__content">
        <!-- src="https://xn--nid4h0ai.com/assets/YANGON-SANDS-MOTION-2_4_(1)_1782368352028-MDZTxEl-.gif" -->
        <img
          class="login-page__logo"
          src="https://storage.googleapis.com/spacetech2/ys/logo1.avif"
          alt="Yangon Sands"
          @click="$router.push('/home')"
        />

        <div class="login-panel">
          <div class="login-panel__accent"></div>

          <div class="login-panel__header">
            <h1 class="login-panel__title">
              {{ $store.state.language === 'en' ? 'Create Account' : 'အကောင့်အသစ် ဖွင့်မည်' }}
            </h1>
            <p class="login-panel__subtitle">
              {{
                $store.state.language === 'en'
                  ? 'Sign up to start playing'
                  : 'ဂိမ်းကစားရန် အကောင့်အသစ် ဖွင့်ပါ'
              }}
            </p>
          </div>

          <div
            v-if="errorMessage"
            class="login-panel__alert"
          >
            <i
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            <span>{{ errorMessage }}</span>
          </div>

          <form
            class="login-panel__form"
            role="form"
            @submit.prevent="registerAccount"
          >
            <div class="login-field">
              <label class="login-field__label">{{ $t('auth.username') }}</label>
              <div class="login-field__control">
                <i
                  class="fas fa-user login-field__icon"
                  aria-hidden="true"
                ></i>
                <input
                  v-model="name"
                  class="login-field__input"
                  type="text"
                  :placeholder="$store.state.language === 'en' ? 'Enter username' : 'အသုံးပြုသူအမည် ထည့်ပါ'
                    "
                  @keyup.enter="focusField('phone')"
                />
              </div>
              <small
                v-if="errors.name"
                class="login-field__error"
              >{{ errors.name }}</small>
            </div>

            <div class="login-field">
              <label class="login-field__label">{{ $t('auth.phone') }}</label>
              <div class="login-field__control">
                <i
                  class="fas fa-mobile-alt login-field__icon"
                  aria-hidden="true"
                ></i>
                <input
                  ref="phone"
                  v-model="phone"
                  class="login-field__input"
                  type="text"
                  :placeholder="$store.state.language === 'en' ? 'Enter phone number' : 'ဖုန်းနံပါတ် ထည့်ပါ'
                    "
                  @keyup.enter="focusField('password')"
                />
              </div>
              <small
                v-if="errors.phone"
                class="login-field__error"
              >{{ errors.phone }}</small>
            </div>

            <div class="login-field">
              <label class="login-field__label">{{ $t('auth.password') }}</label>
              <div class="login-field__control">
                <i
                  class="fas fa-lock login-field__icon"
                  aria-hidden="true"
                ></i>
                <input
                  ref="password"
                  v-model="password"
                  class="login-field__input login-field__input--password"
                  type="password"
                  :placeholder="$store.state.language === 'en' ? 'Enter password' : 'စကားဝှက် ထည့်ပါ'
                    "
                  @keyup.enter="focusField('confirm_password')"
                />
                <button
                  type="button"
                  class="login-field__toggle"
                  :aria-label="$store.state.language === 'en' ? 'Toggle password' : 'စကားဝှက် ပြရန်'"
                  @click="togglePassword('password')"
                >
                  <i
                    :class="isShowPassword ? 'far fa-eye' : 'fas fa-eye-slash'"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
              <small
                v-if="errors.password"
                class="login-field__error"
              >{{ errors.password }}</small>
            </div>

            <div class="login-field">
              <label class="login-field__label">{{ $t('auth.confirm_password') }}</label>
              <div class="login-field__control">
                <i
                  class="fas fa-lock login-field__icon"
                  aria-hidden="true"
                ></i>
                <input
                  ref="confirm_password"
                  v-model="confirm_password"
                  class="login-field__input login-field__input--password"
                  type="password"
                  :placeholder="$store.state.language === 'en'
                      ? 'Confirm your password'
                      : 'စကားဝှက် ထပ်ထည့်ပါ'
                    "
                  @keyup.enter="focusField('referral_code')"
                />
                <button
                  type="button"
                  class="login-field__toggle"
                  :aria-label="$store.state.language === 'en' ? 'Toggle confirm password' : 'စကားဝှက် ပြရန်'
                    "
                  @click="togglePassword('confirm_password')"
                >
                  <i
                    :class="isShowConfirmPassword ? 'far fa-eye' : 'fas fa-eye-slash'"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
              <small
                v-if="errors.confirm_password"
                class="login-field__error"
              >
                {{ errors.confirm_password }}
              </small>
            </div>

            <div class="login-field">
              <label class="login-field__label">
                {{ $t('auth.referral_code') }}
                <span class="login-field__optional">{{ $t('auth.optional') }}</span>
              </label>
              <div class="login-field__control">
                <i
                  class="fas fa-link login-field__icon"
                  aria-hidden="true"
                ></i>
                <input
                  ref="referral_code"
                  v-model="referralCode"
                  class="login-field__input"
                  type="text"
                  :placeholder="$t('auth.referral_code_placeholder')"
                  @keyup.enter="registerAccount"
                />
              </div>
            </div>

            <button
              type="submit"
              class="login-panel__submit"
              :disabled="isSigningUp"
            >
              <span
                v-if="!isSigningUp"
                class="login-panel__submit-text"
              >
                <i
                  class="fas fa-user-plus"
                  aria-hidden="true"
                ></i>
                {{ $t('auth.sign_up') }}
              </span>
              <Loading
                v-else
                color="#1a1a1a"
                size="24"
              />
            </button>
          </form>

          <div class="login-panel__footer">
            <div class="login-panel__divider">
              <span>{{ $store.state.language === 'en' ? 'OR' : 'သို့မဟုတ်' }}</span>
            </div>
            <p class="login-panel__footer-text">
              {{
                $store.state.language === 'en'
                  ? 'Already have an account?'
                  : 'အကောင့်ရှိပြီးသားလား?'
              }}
            </p>
            <button
              type="button"
              class="login-panel__secondary"
              @click="$router.push('/auth/login')"
            >
              <i
                class="fas fa-sign-in-alt"
                aria-hidden="true"
              ></i>
              {{ $t('auth.login') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';
import { getApiErrorMessage, mapApiFieldErrors } from '@/libs/getApiErrorMessage';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      phone: null,
      password: null,
      confirm_password: null,
      referralCode: '',
      errorMessage: '',
      errors: {},
      isSigningUp: false,
      isShowPassword: false,
      isShowConfirmPassword: false,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    togglePassword(field) {
      const ref = this.$refs[field];
      if (field === 'password') {
        ref.type = this.isShowPassword ? 'password' : 'text';
        this.isShowPassword = !this.isShowPassword;
      } else {
        ref.type = this.isShowConfirmPassword ? 'password' : 'text';
        this.isShowConfirmPassword = !this.isShowConfirmPassword;
      }
    },
    focusField(field) {
      this.$refs[field].focus();
    },
    async registerAccount() {
      this.isSigningUp = true;
      this.errors = {};
      this.errorMessage = '';

      if (!this.name) {
        this.errors.name =
          this.$store.state.language === 'en'
            ? 'Username is required'
            : 'User name လိုအပ်ပါသည်။';
        this.isSigningUp = false;
        return false;
      }
      if (!this.phone) {
        this.errors.phone =
          this.$store.state.language === 'en'
            ? 'Phone number is required'
            : 'Phone လိုအပ်ပါသည်။';
        this.isSigningUp = false;
        return false;
      }
      if (!this.password) {
        this.errors.password =
          this.$store.state.language === 'en'
            ? 'Password is required'
            : 'Password လိုအပ်ပါသည်။';
        this.isSigningUp = false;
        return false;
      }
      if (!this.confirm_password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Confirm password is required'
            : 'Confirm Password လိုအပ်ပါသည်။';
        this.isSigningUp = false;
        return false;
      }
      if (this.confirm_password !== this.password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Passwords do not match'
            : 'Password not match!';
        this.isSigningUp = false;
        return false;
      }

      try {
        const code = (this.referralCode || '').trim();
        if (code) {
          localStorage.setItem('referralCode', code);
        }

        const res = await this.axios.post('/auth/register', {
          user_name: this.name,
          phone: this.phone,
          password: this.password,
          confirmPassword: this.confirm_password,
          roles: 'normal',
          referralCode: code || localStorage.getItem('referralCode') || null,
        });

        localStorage.setItem('username', this.phone);
        localStorage.setItem('password', this.password);
        localStorage.setItem('token', res.data.token);

        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000)
        );

        await this.fetchUser();
        this.$router.push('/home');
        Toast.success(
          this.$store.state.language === 'en' ? 'Success!' : 'Success!'
        );
      } catch (err) {
        const { message, fieldErrors } = getApiErrorMessage(
          err,
          this.$store.state.language === 'en'
            ? 'Registration failed. Please try again.'
            : 'အကောင့်ဖွင့်ခြင်း မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။'
        );
        mapApiFieldErrors(fieldErrors, {
          user_name: 'name',
          phone: 'phone',
          password: 'password',
          confirmPassword: 'confirm_password',
        }, this.errors);
        const hasFieldError = fieldErrors.user_name
          || fieldErrors.phone
          || fieldErrors.password
          || fieldErrors.confirmPassword;
        this.errorMessage = hasFieldError ? '' : message;
      }

      this.isSigningUp = false;
      return true;
    },
  },
  async mounted() {
    const codeFromQuery = this.$route.query.referralCode || this.$route.query.code;
    const codeFromStorage = localStorage.getItem('referralCode');
    const initialCode = codeFromQuery || codeFromStorage || '';

    if (initialCode) {
      this.referralCode = initialCode;
      localStorage.setItem('referralCode', initialCode);
    }

    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal') {
      this.$router.push('/home');
    }
  },
};
</script>

<style scoped>
.login-page {
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #050505;
}

.login-page__scroll {
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 1.5rem 1rem calc(8rem + env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
}

.login-page__glow {
  position: absolute;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
  opacity: 0.35;
}

.login-page__glow--left {
  top: 10%;
  left: -80px;
  background: rgba(207, 167, 87, 0.45);
}

.login-page__glow--right {
  bottom: 5%;
  right: -60px;
  background: rgba(250, 230, 141, 0.2);
}

.login-page__content {
  width: 100%;
  max-width: 32rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-page__logo {
  width: auto;
  height: 5rem;
  max-width: 90%;
  object-fit: contain;
  margin-bottom: 1.5rem;
  cursor: pointer;
  filter: drop-shadow(0 6px 24px rgba(207, 167, 87, 0.3));
}

.login-panel {
  position: relative;
  width: 100%;
  padding: 0 0 2rem;
  background: linear-gradient(165deg, #1c1c1c 0%, #121212 55%, #0d0d0d 100%);
  border: 1px solid rgba(207, 167, 87, 0.35);
  border-radius: 20px;
  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.55),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
  overflow: hidden;
}

.login-panel__accent {
  height: 4px;
  background: var(--gradient-primary);
}

.login-panel__header {
  padding: 1.5rem 1.75rem 0.25rem;
  text-align: center;
}

.login-panel__title {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 800;
  color: var(--text-gold);
  letter-spacing: 0.02em;
}

.login-panel__subtitle {
  margin: 0.45rem 0 0;
  font-size: 0.88rem;
  color: var(--text-secondary);
}

.login-panel__alert {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin: 1.25rem 1.75rem 0;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  background: rgba(207, 67, 67, 0.12);
  border: 1px solid rgba(255, 120, 120, 0.25);
  color: #ffb4b4;
  font-size: 0.88rem;
}

.login-panel__form {
  padding: 1.25rem 1.75rem 0;
}

.login-field {
  margin-bottom: 1.15rem;
}

.login-field__label {
  display: block;
  margin-bottom: 0.45rem;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.login-field__optional {
  margin-left: 0.35rem;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: none;
  color: var(--text-secondary);
  opacity: 0.85;
}

.login-field__control {
  position: relative;
  display: flex;
  align-items: center;
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.login-field__control:focus-within {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(207, 167, 87, 0.18);
}

.login-field__icon {
  flex-shrink: 0;
  width: 2.75rem;
  text-align: center;
  color: var(--text-gold);
  font-size: 1rem;
  opacity: 0.85;
}

.login-field__input {
  flex: 1;
  min-width: 0;
  height: 3rem;
  padding: 0 0.85rem 0 0;
  border: none;
  background: transparent;
  color: var(--text-primary);
  font-size: 1rem;
  outline: none;
}

.login-field__input--password {
  padding-right: 2.75rem;
}

.login-field__input::placeholder {
  color: #666;
}

.login-field__toggle {
  position: absolute;
  right: 0;
  top: 0;
  width: 2.75rem;
  height: 100%;
  border: none;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
}

.login-field__toggle:hover {
  color: var(--text-gold);
}

.login-field__error {
  display: block;
  margin-top: 0.35rem;
  color: #f0a8a8;
  font-size: 0.78rem;
}

.login-panel__submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 3.15rem;
  margin-top: 0.5rem;
  border: none;
  border-radius: 14px;
  background: var(--gradient-primary);
  color: #1a1a1a;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(207, 167, 87, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.login-panel__submit:active:not(:disabled) {
  transform: scale(0.98);
}

.login-panel__submit:disabled {
  opacity: 0.9;
  cursor: wait;
}

.login-panel__submit-text {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.login-panel__footer {
  padding: 0.5rem 1.75rem 1.75rem;
  text-align: center;
}

.login-panel__divider {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  color: var(--text-muted);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
}

.login-panel__divider::before,
.login-panel__divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: rgba(207, 167, 87, 0.25);
}

.login-panel__footer-text {
  margin: 0 0 0.85rem;
  font-size: 0.88rem;
  color: var(--text-secondary);
}

.login-panel__secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  height: 3rem;
  border: 1px solid rgba(207, 167, 87, 0.55);
  border-radius: 14px;
  background: transparent;
  color: var(--text-gold);
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.login-panel__secondary:hover {
  background: rgba(207, 167, 87, 0.08);
  border-color: var(--color-primary);
}

.login-panel__secondary:active {
  transform: scale(0.98);
}

@media (min-width: 480px) {
  .login-page__content {
    max-width: 34rem;
  }

  .login-page__logo {
    height: 5.75rem;
    margin-bottom: 1.75rem;
  }

  .login-panel__header {
    padding: 1.75rem 2.25rem 0.35rem;
  }

  .login-panel__form {
    padding: 1.35rem 2.25rem 0;
  }

  .login-panel__alert {
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .login-panel__footer {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
    padding-bottom: 2rem;
  }
}
</style>
